module.exports = __webpack_public_path__ + "static/media/microsoft-upload.e1c2e120.svg";